<template>
    <div>
        <div class="colspan" id="publicPubM">
            <ul class="clearfix">
                <a 
                    v-for="item in projectCateList" 
                    @click="goto(item)"
                    :key="item.id"  >   
                    <li ref="li" 
                        :class="[item.id == menuId ? 'current' : '',item.id != menuId&&item.id == hoverId ? 'hover' : ''] " 
                        @click="tab(item.id)"
                        @mouseenter="enter(item.id)" 
                        @mouseleave="leave"
                        >
                        <span>{{item.name}}</span>
                        <span class="right"> <i class="el-icon-arrow-right"></i>  </span>
                    </li>
                </a>
                
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            // id:{
            //     type:Number,
            //     default:null,
            // },
            // second_navId:{
            //     type:Number,
            //     default:null,
            // },
            projectCateList:{
                type: Array,
                default:function(){
                    return [];
                }
            }, 
            path:{
                type:String,
                default:''
            }
        },
        data(){
            return {
                id:null,
                second_navId:null,
                menuId:null,
                hoverId:null,
                // menuList:[
                    // {
                    //     id:1,
                    //     title:'一对一精准助学',
                    //     url:''
                    // },
                    // {
                    //     id:2,
                    //     title:'西部阳光助学计划',
                    //     url:''
                    // },
                    // {
                    //     id:3,
                    //     title:'重燃希望',
                    //     url:''
                    // },
                    // {
                    //     id:4,
                    //     title:'是是是撒多军',
                    //     url:''
                    // },
                    // {
                    //     id:5,
                    //     title:'联系我们',
                    //     url:''
                    // },
                    
                // ],
                hover:false
            }
        },
        methods:{
            goto(item){
                this.$router.push({name:'pubPoject',query:{cate_id:item.id}})
            },
            tab(id){
                this.menuId = id;
            },
            enter(id){
                this.hoverId = id;
            },
            leave(){
                this.hoverId = null
            },
       
        },
        mounted(){
        },
       
        created(){
            this.menuId = this.$route.query.cate_id
            // this.second_navId = this.$route.query.second_navId
            // this.menuId = menuId
           
        },
        
        watch:{
            '$route.query.cate_id':function(value) {
                if(value){
                     this.cate_id = value
                }else if(typeof(value)){
                     this.menuId = null
                }
               
                // this.menuId = value
            },
            // '$route.query.second_navId':function(value) {
            //     this.second_navId = value
            //     this.menuId = this.second_navId?this.second_navId:this.id
            // }
          
        }
    }
</script>
<style lang="less" scoped>
    .colspan {
        margin: 0 auto;
        width: 1200px;
        > ul {
            list-style-type: none;
            margin: 0;
            padding: 0;
            float: left;
            margin-right: 20px;
            min-height: 500px;
            > a {
                text-decoration:none;
                    > li {
                    width: 230px;
                    height: 60px;
                    line-height: 60px;
                    box-sizing: border-box;
                    font-size: 18px;
                    color: #888888;
                    border: 1px solid #ddd;
                    padding: 0 10px;
                    cursor: pointer;
                    position: relative;
                    border-top: 0px;
                    > .right {
                        position: absolute;
                        right: 19px;
                        top: 50%;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        border: 1px solid #fff;
                        border-radius: 50%;
                        color: #fff;
                        text-align: center;
                        font-size: 16px;
                        cursor: pointer;
                        transform: translateY(-50%)
                    }
                }
            }
            
             > a > li:nth-of-type(1){
                border-top: 1px solid #ddd;
            }
            > a  > li.current {
                color: #fff;
            }
            > a  > li.hover {
                background-color: #f5f5f5;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Public/pubMenu.vue